/**
 * Restructed by zhang.yingyu
 * Restructed on 2018-04-19
 */
"use strict";
angular.module("eventAnalysisLeftModule", []).
directive("eventAnalysisLeft", ["$state", "$timeout", function($state, $timeout) {
    return {
        restrict: "E",
        replace: true,
        templateUrl: "./planningCenter/eventAnalysis/left/left_tpl.html",
        scope: {
            selected: "="
        },
        link: function(scope, $elem, $attrs) {
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {};
                autoLocation()
            }

            function autoLocation() {
                scope.$watch("selected", (newV, oldV) => {
                    if (newV === "eventanalysis") {
                        let routerName = $state.current.name;
                        if (routerName.indexOf('eventanalysis') >= 0) {
                            scope.$root.narrowNavigation = true;
                        }
                    }
                });
            }
            /**
             * [selectLeve2 description] 选中事件分析
             * @return {[type]}            [description]
             */
            scope.selectLeve1 = function() {
                $state.go("front.plan.eventanalysis.eventanalysismain", "", { reload: "front.plan.eventanalysis.eventanalysismain" });
                scope.$root.narrowNavigation = true;
                if (scope.selected !== "eventanalysis") {
                    $timeout(() => {
                        scope.selected = "eventanalysis";
                    }, 500);
                }
            };
        }
    };
}]);